import RegisterField, { FieldProps } from "../register-field";
import { MonedaField, MonedaFieldProps } from "@/components/inputs";

export default function FormMonedaField({
    name,
    registerOptions,
    ...props
}: FieldProps<MonedaFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <MonedaField
            {...props}

            inputRef={field.ref}
            value={field.value == null ? "" : field.value}
            disabled={field.disabled}

            onValueChange={(v, s) => {
                field.handleChange(v.floatValue == null ? "" : v.floatValue);
                props.onValueChange && props.onValueChange(v, s);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}